import { Component, ElementRef, OnInit, Renderer2} from "@angular/core";
import {UntypedFormBuilder,UntypedFormGroup,UntypedFormArray} from "@angular/forms";
import { ValidateCustomerService } from "./validateCustomer.service";
import { BaseCRUDComponent } from "../../Core/Abstract/baseCRUD.component";
import { LogService } from "../../Core/Abstract/log.service";
import { VisualsService } from "../../Core/Abstract/visuals.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { SecurityService } from '../../Core/Security/security.service';
import { forkJoin } from "rxjs";
import { Subscription } from 'rxjs';
import { ConfigService } from '../../Core/Abstract/config.service';

@Component({
  selector: "validateCustomer-grid",
  templateUrl: "./validateCustomer.component.html",
  providers: [ValidateCustomerService]
})    
export class ValidateCustomerComponent extends BaseCRUDComponent<ValidateCustomerService>implements OnInit {
  form :any;
  options: FormlyFormOptions = {};
  model;
  ob:any;
  termsTemplate:any;
  clusterTerms:any;
  subscription: Subscription;
  subscriptionSubmit: Subscription;
  fields;
  userId: any;
  crsId: any;
  isOrigin: any;
  hasBackGround: any;
  loading: boolean = false;
  buyerCompanyInfo:any;
  welcomeFormData:any = {} ;
  protected hasOtp: boolean = false;
  protected allowRegenerateOtp: boolean = false;
  protected timerSeconds: number;
  protected resetTimer: boolean = false;
  protected uuid : string;
  protected type: string;

  
  constructor(
    private securityService: SecurityService,
    private service: ValidateCustomerService,
    private configService:ConfigService,
    fb: UntypedFormBuilder,
    logger: LogService,
    visualsService: VisualsService,
    route: ActivatedRoute,
    router: Router
  ) {
    super(logger, visualsService, route, fb, router);
    this.group = 'validateCustomer';
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.crsId = this.route.snapshot.queryParamMap.get('crsId');
    this.uuid = this.route.snapshot.queryParamMap.get('uuid');
    this.type = this.route.snapshot.queryParamMap.get('type');
    this.ob = this.route.snapshot.queryParamMap.get('ob');
    this.isOrigin = this.route.snapshot.queryParamMap.get('isOrigin');
    this.getFormConfigAndData()
    this.timerSeconds = Number(localStorage.getItem('timerSeconds') || 0);
    this.hasOtp = this.securityService.isOtpEnabled();
    this.allowRegenerateOtp = this.securityService.allowRegenerateOtp();
  }
  getFormConfigAndData(){
     
    this.loading = true;
    this.subscription = forkJoin(this.service.getFields(this.userId), this.service.loadBean(this.userId),this.visualsService.getParam('WELCOME_SCREEN_BACKGROUND')).subscribe(
        response =>{ 
          this.fields = this.mapFields(JSON.parse(response[0].data.valForm)).fields;
          this.form = new UntypedFormArray(this.fields.map(() => new UntypedFormGroup({})));
          this.hasBackGround = response[2].paramValStr; 
          if(this.hasBackGround == 'Y'){
            let url = '/assets/images/logo/'+this.configService.getClient()+'/welcome-screen.png';
            document.querySelector("body").style.backgroundImage = "url("+url+")";
            document.querySelector("body").style.backgroundSize = "cover";
            document.querySelector("body").style.backgroundPosition = "center";
            document.querySelector("body").style.backgroundRepeat = "no-repeat";
          }
          this.loading = false
        },
        error => console.log("Error: ", error),
        () =>{
          
        }
    )
  }
  
    submit(){
      if (!this.form.valid) {
        return
      }
      let formToSend = [];
      this.welcomeFormData = localStorage.getItem('welcomeFormData')? JSON.parse(localStorage.getItem('welcomeFormData')):{};
      formToSend[0] = { ...this.form.value[0], ...this.welcomeFormData[0] };
      // this.loading = true;
      this.subscriptionSubmit = forkJoin(this.service.validate(formToSend,this.userId,this.crsId,this.uuid,this.type),this.service.save(formToSend,this.userId)).subscribe(
          response =>{ 
            this.securityService.router.navigate(['/menu/onboard'], {queryParams: {userId: this.userId,isOrigin:this.isOrigin}});
              LogService.emitAlert({
                type: "success",
                body: this.genericVisuals.dataSaved
            });
            this.loading = false;
          },
          error => {
            this.loading = false;
            this.resetTimer = false;
            console.log("Error: ", error)
            LogService.emitAlert({
              type: "error",
              body: error.error.message
          });
          },
          () =>{
            this.loading = false;
          }
      )

    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    public actionTimerReset(reset: boolean){
      if(reset){
          this.resetTimer = false;
      }
  }

    public requestNewOtpWelcome(limits: boolean = false){
      this.loading = true;
      console.log('regenerate clicked');
      if(limits){
          this.resetTimer = true;
      }
      this.welcomeFormData = localStorage.getItem('welcomeFormData')? JSON.parse(localStorage.getItem('welcomeFormData')):{};
      let formToSend = [];
      formToSend[0] = { ...this.form.value[0], ...this.welcomeFormData[0] };
      this.service.generaeteOtpWelcome(formToSend,this.userId,this.crsId,this.uuid).subscribe(
          data => {
              this.form.reset();
              this.loading = false;
              LogService.emitAlert({
                type: "success",
                body: this.genericVisuals.otpGenerated
              });
          },
          error => {
              this.form.reset();
              this.loading = false;
              console.log("Error: ", error)
              LogService.emitAlert({
                type: "error",
                body: error.error.message
            });
              
          }
      )
  }
  }
